import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Button } from "./Button";

export function Layout() {
  const { user, logout } = useAuth();
  return (
    <div className="shell">
      <aside className="sidebar">
        <h1 className="brand">Persona Admin</h1>
        <nav aria-label="Menu utama">
          <NavLink to="/articles" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
            Artikel
          </NavLink>
          <NavLink to="/intros" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
            Pengantar Tes
          </NavLink>
        </nav>
        <div className="sidebar-foot">
          <span className="who">{user?.username ?? user?.email}</span>
          <Button variant="secondary" onClick={() => void logout()}>
            Keluar
          </Button>
        </div>
      </aside>
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
